module.exports = __webpack_public_path__ + "img/maassen.84d8fdb8.jpg";